// @flow
import axios from 'lib/defaultClient';

export const listForMe = params => axios.get(`/me/orders`, { params });
export const downloadInventoriesExcelForMe = () => axios.post(`/me/orders/inventories`);
export const downloadRequestsExcelForMe = () => axios.post(`/me/orders/requests`);
export const countForMe = () => axios.get(`/me/orders/count`);
export const getForMe = (orderId, params) => axios.get(`/me/orders/${orderId}`, { params });
export const authenticate = orderId => axios.post(`/me/orders/${orderId}/auth`);
export const updateForMe = (orderId, payload) => axios.put(`/me/orders/${orderId}`, payload);
export const createDownloadUrlForMe = (orderId, itemId, payload) =>
  axios.post(`/me/orders/${orderId}/items/${itemId}/download/url`, payload);
export const requestRefundForMe = (orderId, payload) =>
  axios.post(`/me/orders/${orderId}/refunds`, payload);
export const updateRefundForMe = (orderId, refundId, payload) =>
  axios.put(`/me/orders/${orderId}/refunds/${refundId}`, payload);
export const cancelRefundForMe = (orderId, refundId, payload) =>
  axios.post(`/me/orders/${orderId}/refunds/${refundId}/cancellation`, payload);
export const updateRefundCancellationForMe = (orderId, refundId, payload) =>
  axios.put(`/me/orders/${orderId}/refunds/${refundId}/cancellation`, payload);
export const markAsNotReceivedForMe = orderId => axios.delete(`/me/orders/${orderId}/received`);
export const markAsReceivedForMe = orderId => axios.post(`/me/orders/${orderId}/received`);
export const cancelForMe = (orderId, payload) =>
  axios.post(`/me/orders/${orderId}/cancellation`, payload);
export const deleteForMe = orderId => axios.delete(`/me/orders/${orderId}`);
export const updateCancellationForMe = (orderId, payload) =>
  axios.put(`/me/orders/${orderId}/cancellation`, payload);
export const updateTransactionsForMe = (orderId, payload) =>
  axios.put(`/me/orders/${orderId}/transactions`, payload);
export const listBySubscriptionForMe = (orderId, subscriptionId, payload) =>
  axios.get(`/me/orders/${orderId}/subscriptions/${subscriptionId}/orders`, payload);
export const getShippingTracking = (orderId: string, fulfillmentId: string, token: string) =>
  axios.get(`/me/orders/${orderId}/shipping-tracking/${fulfillmentId}?token=${token}`);
export const generateNonRegisteredOrderToken = (orderId: string, email: string) =>
  axios.post(`/me/non-registered/orders/token`, { orderId, email });



// WEBPACK FOOTER //
// ./src/lib/api/me/orders.js